export function normalizeBoxItemName(boxItemName: string): string {
    // Folder and file name cannot contain / \ and can't end with spaces
    return boxItemName.replaceAll(/[\\/]/g, '-').trimEnd();
}
